import React, {useRef} from 'react';
import {SearchBar, useSearch} from '../../Components/Search';
import Form, { Radio, TextField, Actions } from '../../Components/Form';
import { useModal } from '../../Components/Modal';

const Search = ({isLoading}) => {
    const {searchData, setSearchData} = useSearch();
    const submitRef = useRef();

    const form = <FilterForm data={searchData} updateSearch={setSearchData} submitRef={submitRef} />;

    return <SearchBar filterForm={form}
                isLoading={isLoading}
                modalOptions={{
                    title: 'Search quotes',
                    theme: 'primary',
                    icon: 'MagnifyingGlass',
                    initialFocus: submitRef,
                }}
            />
}

const FilterForm = ({data, updateSearch, submitRef}) => {
    const {closeModal} = useModal();
    
    const handleSubmit = (data) => {
        updateSearch(data);
        closeModal();
    }

    const clearSearch = () => {
        updateSearch({});
        closeModal();
    }

    return <Form onSubmit={handleSubmit} data={data}>
        <TextField name="search" label="Search" />
        
        <Radio name="closed"
            label="Closed quotes"
            layout="SmallCards"
            options={[
                { value: '', label: 'Either' },
                { value: 'true', label: 'Yes' },
                { value: 'false', label: 'No' },
            ]}
        />
        <Actions submit={{label: 'Search', btnRef: submitRef}} cancel={{label: 'Clear', onClick: clearSearch}} />
    </Form>
}

export default Search;